import React from "react";
import { useSelector } from "react-redux";
import {
  AgenciesGetResponse,
  ClientResponse,
  ErrorWithMessage,
  ReduxStoreRoot,
} from "../../types";
import { useQuery } from "@tanstack/react-query";
import { fetchFunction } from "../../util";
import { Box, Center, Loading, Title, Text } from "@thecb/components";
import Agency from "../../types/api/models/agency";
import { TableWrapper } from "../../components/styled";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeading,
  TableRow,
  TableRowEntry,
} from "../../components/table";
import { useHistory } from "react-router-dom";

const tableColumns = ["Agency", "Slug"];

const AgenciesTable = () => {
  const history = useHistory();
  const { posApiEndpoint } = useSelector((state: ReduxStoreRoot) => state.config);

  const {
    client: {
      value: { brand: selectedBrand },
    },
  } = useSelector((state: ReduxStoreRoot) => state.currentUser);

  const { data: clientsGETResponse, isFetching: isFetchingClient } = useQuery<
    ClientResponse,
    ErrorWithMessage
  >({
    queryKey: [`GET -> /clients/${selectedBrand}`],
    queryFn: () => fetchFunction(`${posApiEndpoint}/clients/${selectedBrand}`),
  });
  const { data: agenciesGETResponse, isFetching: isFetchingAgencies } = useQuery<
    AgenciesGetResponse,
    ErrorWithMessage
  >({
    queryKey: [
      `GET -> /agencies/${clientsGETResponse?.data.id}?brand=${selectedBrand}`,
    ],
    queryFn: () =>
      fetchFunction(`${posApiEndpoint}/agencies?brand=${selectedBrand}`),
  });

  if (isFetchingClient || isFetchingAgencies) {
    return <Loading />;
  }

  const onRowClick = (agency: Agency) =>
    history.push(`${history.location.pathname}/${agency.id}/edit`);

  return (
    <TableWrapper>
      <Table>
        <TableHeader>
          {tableColumns.map((c, idx) => (
            <TableHeading key={idx}>{c}</TableHeading>
          ))}
        </TableHeader>
        <TableBody>
          {agenciesGETResponse?.data.map((a, index) => (
            <TableRow key={index} onClick={() => onRowClick(a)}>
              <TableRowEntry>{a.description}</TableRowEntry>
              <TableRowEntry extraStyles={`text-align: right;`}>
                {a.slug}
              </TableRowEntry>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!agenciesGETResponse?.data.length && (
        <Box padding="64px" minWidth="100%">
          <Center intrinsic>
            <Title as="h2" weight="700" margin="0 0 0.25rem">
              No Agencies
            </Title>
            <Text>
              This client has no agencies. Create an agency to see them listed here.
            </Text>
          </Center>
        </Box>
      )}
    </TableWrapper>
  );
};

export default AgenciesTable;
